var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg04Calm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 59.9999C46.5685 59.9999 59.9999 46.5685 59.9999 29.9999C59.9999 13.4314 46.5685 0 29.9999 0C13.4314 0 0 13.4314 0 29.9999C0 46.5685 13.4314 59.9999 29.9999 59.9999Z",
    fill: "#83CDF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.4286 55.5707C19.8601 55.5707 6.42875 42.1393 6.42875 25.5709C6.42875 16.7189 10.2633 8.76372 16.3612 3.27246C6.64894 8.23837 0 18.3425 0 29.9996C0 46.5681 13.4314 59.9994 29.9998 59.9994C37.7165 59.9994 44.7517 57.085 50.0672 52.2982C45.9753 54.3903 41.34 55.5707 36.4286 55.5707Z",
    fill: "#3A79B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8163 21.934C28.1422 21.934 27.5959 21.3876 27.5959 20.7136C27.5959 19.1395 26.315 17.8587 24.741 17.8587C23.1669 17.8587 21.8861 19.1396 21.8861 20.7136C21.8861 21.3877 21.3396 21.934 20.6657 21.934C19.9916 21.934 19.4453 21.3876 19.4453 20.7136C19.4453 17.7936 21.8209 15.418 24.741 15.418C27.6611 15.418 30.0367 17.7936 30.0367 20.7136C30.0368 21.3876 29.4903 21.934 28.8163 21.934Z",
    fill: "#3A79B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4296 21.934C48.7555 21.934 48.2092 21.3876 48.2092 20.7136C48.2092 19.1395 46.9283 17.8587 45.3543 17.8587C43.7802 17.8587 42.4994 19.1396 42.4994 20.7136C42.4994 21.3877 41.9529 21.934 41.279 21.934C40.605 21.934 40.0586 21.3876 40.0586 20.7136C40.0586 17.7936 42.4342 15.418 45.3543 15.418C48.2743 15.418 50.6499 17.7936 50.6499 20.7136C50.6501 21.3876 50.1036 21.934 49.4296 21.934Z",
    fill: "#3A79B9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4057 47.2705C32.1726 47.2705 29.186 45.5144 27.6115 42.6876C27.2835 42.0987 27.495 41.3554 28.0838 41.0275C28.6725 40.6995 29.4158 40.911 29.7438 41.4998C30.8879 43.5538 33.0574 44.8296 35.4057 44.8296C37.6941 44.8296 39.8883 43.5408 41.132 41.4661C41.4787 40.8882 42.2283 40.7003 42.8063 41.047C43.3845 41.3936 43.5721 42.1431 43.2255 42.7212C41.5432 45.5275 38.5468 47.2705 35.4057 47.2705Z",
    fill: "#3A79B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04Calm);
export default __webpack_public_path__ + "static/media/04-Calm.74a493ec8ea31d4e961b9580d046b989.svg";
export { ForwardRef as ReactComponent };